import "whatwg-fetch";
import {START, SUCCESS, FAIL} from "../constants";

const cache = {};

export default () => (next) => (action) => {
  const {callAPI, type, ...rest} = action;
  if (!callAPI) {
    return next(action);
  }

  next({
    type: type + START,
    ...rest
  });

  if (cache[callAPI]) {
    next({
      ...rest,
      response: {...(cache[callAPI].state || cache[callAPI])},
      type: type + SUCCESS
    });
  } else {
    fetch(callAPI, {
      headers: {
        "Accept": `application/json`,
        "Content-Type": `application/json`
      },
      credentials: `same-origin`
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error(`Error`);
        }
        return res.json();
      })
      .then((response) => {
        cache[callAPI] = {...response}; // add to local cache
        return next({
          ...rest,
          response: response.state || response,
          type: type + SUCCESS
        });
      })
      .catch((error) => next({...rest, error, type: type + FAIL}));
  }

  return void 0;
};
